import LazyLoad from 'components/LazyLoad'
import Image from 'components/LegacyImage'
import { ArticleSubsections } from 'types/data/Article'

interface ContentProps {
  subsection: ArticleSubsections
}

const Content = ({ subsection }: ContentProps) => {
  const courseGemVideos =
    subsection.videoId || subsection.mediaUuid
      ? [
          {
            videoId: subsection.videoId,
            mediaUuid: subsection.mediaUuid,
            videoName: subsection.title,
          },
        ]
      : subsection.upNextGems

  return (
    <div className='mc-pb-6 mc-mst-12' id={subsection.id ?? undefined}>
      {subsection.title && (
        <h2
          className='mc-text-h2 highlight-shareable'
          dangerouslySetInnerHTML={{ __html: subsection.title }}
        />
      )}
      {subsection.description && (
        <div
          className='mc-text-large mc-mt-4 highlight-shareable'
          dangerouslySetInnerHTML={{ __html: subsection.description }}
        />
      )}
      {subsection.mediaImageUrl && (
        <Image
          alt={subsection.mediaCaption ?? undefined}
          className='d-block mc-img-responsive'
          height={444}
          objectFit='cover'
          src={subsection.mediaImageUrl}
          width={790}
        />
      )}
      {courseGemVideos && (
        <LazyLoad
          loader={() => import('../FeaturedCourseGem')}
          height={320}
          offset={1400}
          ssr={false}
          videos={courseGemVideos}
        />
      )}
    </div>
  )
}

export default Content
